import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import React, { FC } from 'react';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';
import MUIAlert from '../../../ui-component/mui-alert/MUIAlert';

// import schemas
import Schema from 'src/lib/paths/user_Paths.json';
const P = Schema.attributes;

const LoginDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	loginDatenError: any;
	formErrorMessage: string;
}> = ({ formValue, updateFunction, loginDatenError, formErrorMessage }) => {
	return (
		<>
			<ApplicationHeading title='Ihre Zugangsdaten' description='' />
			<Typography variant='body1' mb={2}>
				Bitte legen Sie hier Ihren Benutzernamen und Ihr Passwort fest. Das Passwort können Sie später in Ihrem Profil ändern, der Benutzername
				ist mit der Registrierung festgelegt.
			</Typography>
			{formErrorMessage && (
				<MUIAlert infoType='error' message='Sie sind bereit registriert. Fragen Sie Ihren Nutzerverwalter für die Freischaltung des Account' />
			)}
			<Grid2 container>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucEmail()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
						readOnly={true}
					/>
				</Grid2>
			</Grid2>

			<Grid2 container>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucUsername()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
			</Grid2>

			<Grid2 container>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucPassword()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
				<Grid2 sm={12}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucPassword2()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default LoginDaten;

const formStrucEmail = () => {
	return [
		{
			fields: [P.email],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucUsername = () => {
	return [
		{
			fields: [P.username],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucPassword = () => {
	return [
		{
			fields: [
				{
					...P.password,
					tooltip:
						'Passwort muss mindestens 8 Zeichen lang sein und mindestens ein Symbol, einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten.',
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucPassword2 = () => {
	return [
		{
			fields: [P.repeatPassword],
			userProps: { columnToDivide: 1 },
		},
	];
};
